.bb{overflow:hidden;}